import { render, staticRenderFns } from "./AuditNotice.vue?vue&type=template&id=0cb15c50&scoped=true"
import script from "./AuditNotice.vue?vue&type=script&lang=js"
export * from "./AuditNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb15c50",
  null
  
)

export default component.exports